import React from 'react';
import './PositionList.css'; // Import the CSS file

const PositionsListOverlay = ({ setPosition, onBackdropClick, visible }) => {
  const handleSelect = (val) => {
    setPosition(val);
    onBackdropClick();
  };  

  if (!visible) return null; // If not visible, return null to avoid rendering

  return (
    <div className="positionOverlay" onClick={onBackdropClick}>
      <div className="modalView" onClick={(e) => e.stopPropagation()}>
        <h2 className="selectPositionTxt">SELECT POSITION</h2>
        {list.map((val, i) => (
          <button key={i} className="btn" onClick={() => handleSelect(val)}>
            <span className="option">{val}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PositionsListOverlay;

const list = ['A', 'M', 'D', 'G', 'FO', 'LSM', 'DM', 'None'];
